<template>
  <div class="grafik-tier-source mb-1">
    <div class="row">
      <div
        v-if="activeChannel && activeChannel.google.news_status == 1"
        class="px-gap"
        :class="
          activeChannel && activeChannel.formed.cetak_status == 1
            ? 'col-md-6'
            : 'col-md-12'
        "
      >
        <div class="card card-default shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Tier Online News</h4>
                  <p class="small hint-text">Grafik per Tier Online News</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <loader-component v-if="is_loading" />
                <div v-else>
                  <div
                    v-if="!data || data.news.series.length == 0"
                    class="alert alert-danger"
                    role="alert"
                    align="center"
                  >
                    <strong> Mohon maaf, data tidak tersedia! </strong>
                    <br />
                    Tidak dapat menampilkan grafik dengan data kosong.
                  </div>
                  <bar-chart-component
                    v-else
                    :dataset="data.news.series || []"
                    yLabel="Frekuensi"
                    :is_clickable="false"
                    barchart_id="barchart-tier-news"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="activeChannel && activeChannel.formed.cetak_status == 1"
        class="px-gap"
        :class="
          activeChannel && activeChannel.google.news_status == 1
            ? 'col-md-6'
            : 'col-md-12'
        "
      >
        <div class="card card-default shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Tier Media Cetak</h4>
                  <p class="small hint-text">Grafik per Tier Media Cetak</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <loader-component v-if="is_loading" />
                <div v-else>
                  <div
                    v-if="!data || data.media_cetak.series.length == 0"
                    class="alert alert-danger"
                    role="alert"
                    align="center"
                  >
                    <strong> Mohon maaf, data tidak tersedia! </strong>
                    <br />
                    Tidak dapat menampilkan grafik dengan data kosong.
                  </div>
                  <bar-chart-component
                    v-else
                    :dataset="data.media_cetak.series || []"
                    yLabel="Frekuensi"
                    :is_clickable="false"
                    barchart_id="barchart-tier-media-cetak"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4 px-gap">
        <div class="card card-default shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Tier Media TV</h4>
                  <p class="small hint-text">Grafik per Tier Media TV</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <bar-chart-component
                  :dataset="data_media_tv.series"
                  :yLabel="data_media_tv.yLabel"
                  :is_clickable="false"
                  barchart_id="barchart-tier-media-tv"
                />
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import bar_chart_highchart from "@/views/components/chart/bar_chart_highchart.vue";
import loader_component from "@/views/components/loader.vue";

export default {
  name: "medkon_tier_source",
  components: {
    "bar-chart-component": bar_chart_highchart,
    "loader-component": loader_component,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return null;
      },
    },
    activeChannel: {
      type: Object,
      default: function() {
        return null;
      },
    },
  },
  data() {
    return {
      data_news: {
        series: [],
        yLabel: "Frekuensi",
      },
      data_media_cetak: {
        series: [],
        yLabel: "Frekuensi",
      },
      // data_media_tv: {
      //   series: this.data.media_tv.series || [],
      //   yLabel: "Frekuensi",
      // },
    };
  },
  mounted() {
    if (this.data) {
      this.data_news.series = this.data.news.series;
      this.data_media_cetak.series = this.data.media_cetak.series;
    }
  },
};
</script>
